import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { AvaliacaoHabilidade } from "../../models/avaliacao_habilidade";
import { IGetHabilidadesUseCase } from "../../../presentation/useCases/read/get_habilidades_use_case";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * GetHabilidadesUseCase
 */

export class GetHabilidadesUseCase extends BasePaginatedUseCase<AvaliacaoHabilidade> implements IGetHabilidadesUseCase {
  constructor(
    private readonly repository: IRhRepository,
  ) {
    super();
  }

  async getHabilidades(
    idFuncionario: number,
    page: number,
    pageSize: number,
  ): Promise<void> {
    const response = await this.repository.getAvaliacaoHabilidades(idFuncionario, page, pageSize);

    this._items = response.items;
    this._totalItems = response.totalItems;
    this._totalPages = response.totalPages;
    this._currentPage = response.currentPage;
    this._pageSize = response.pageSize;
  }
}